/* ──────────────────────────────────────────────────────────────
   src/pages/reports/asignaturas/AsignaturasReportsLayout.tsx
   Layout para informes de asignaturas
   ────────────────────────────────────────────────────────────── */

import { Outlet, NavLink } from 'react-router-dom';
import { Box, Typography, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GroupsIcon from '@mui/icons-material/Groups';
import FunctionsIcon from '@mui/icons-material/Functions';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { useTranslation } from 'react-i18next';

const linkSx = (isActive: boolean) => ({
  bgcolor: isActive ? 'action.selected' : 'transparent',
  color: isActive ? 'primary.main' : 'text.primary',
  '& .MuiListItemIcon-root': {
    color: isActive ? 'primary.main' : 'inherit',
    minWidth: 32,
  },
});

export default function AsignaturasReportsLayout() {
  const { t } = useTranslation<'translation'>();

  return (
    <Box sx={{ display: 'flex', minHeight: '100%' }}>
      <Box
        sx={{
          width: 220,
          borderRight: 1,
          borderColor: 'divider',
          px: 2,
          py: 3,
        }}
      >
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t('asigReportsLayout.titulo')}
        </Typography>

        <List dense disablePadding>
          <NavLink to="semanal">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <BarChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('asigReportsLayout.menu.semanal')} />
              </ListItemButton>
            )}
          </NavLink>

          <NavLink to="profesores">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <PeopleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('asigReportsLayout.menu.profesores')} />
              </ListItemButton>
            )}
          </NavLink>

          <NavLink to="demanda">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <TrendingUpIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('asigReportsLayout.menu.demanda')} />
              </ListItemButton>
            )}
          </NavLink>

          <NavLink to="alumnos-unicos">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <GroupsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('asigReportsLayout.menu.alumnosUnicos')} />
              </ListItemButton>
            )}
          </NavLink>

          <NavLink to="ratio-profesor">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <FunctionsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('asigReportsLayout.menu.ratio')} />
              </ListItemButton>
            )}
          </NavLink>

          <NavLink to="centro-formato">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <CompareArrowsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('asigReportsLayout.menu.centroFormato')} />
              </ListItemButton>
            )}
          </NavLink>
        </List>
      </Box>

      <Box sx={{ flex: 1, p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
